// Launcher targets. `uri` = desktop app protocol (must be installed). `web` = website.
import {
  Gamepad2, Boxes, MessageCircle, Music, Globe, Youtube, Twitch, Github,
  Cloud, Ghost, Store, Clapperboard,
} from "lucide-react";

// Desktop apps launched via their registered URL scheme
export const APPS = [
  { id: "steam", name: "Steam", uri: "steam://open/main", icon: Gamepad2, color: "#66c0f4" },
  { id: "curseforge", name: "CurseForge", uri: "curseforge://", icon: Boxes, color: "#f16436" },
  { id: "discord", name: "Discord", uri: "discord://", icon: MessageCircle, color: "#5865f2" },
  { id: "spotify", name: "Spotify", uri: "spotify://", icon: Music, color: "#1db954" },
  { id: "epic", name: "Epic Games", uri: "com.epicgames.launcher://apps", icon: Store, color: "#ffffff" },
  { id: "battlenet", name: "Battle.net", uri: "battlenet://", icon: Ghost, color: "#00aeff" },
];

// Website tabs (direct access)
export const SITES = [
  { id: "google", name: "Google", web: "https://www.google.com", icon: Globe, color: "#8ab4f8" },
  { id: "youtube", name: "YouTube", web: "https://www.youtube.com", icon: Youtube, color: "#ff0000" },
  { id: "twitch", name: "Twitch", web: "https://www.twitch.tv", icon: Twitch, color: "#9146ff" },
  { id: "github", name: "GitHub", web: "https://github.com", icon: Github, color: "#ffffff" },
  { id: "netflix", name: "Netflix", web: "https://www.netflix.com", icon: Clapperboard, color: "#e50914" },
  { id: "drive", name: "Drive", web: "https://drive.google.com", icon: Cloud, color: "#4285f4" },
];

// Launch a target: protocol via hidden iframe (keeps SPA), website in new tab.
export function launchTarget(t) {
  if (t.web) { window.open(t.web, "_blank", "noopener"); return; }
  if (t.uri) {
    try {
      const f = document.createElement("iframe");
      f.style.display = "none";
      f.src = t.uri;
      document.body.appendChild(f);
      setTimeout(() => f.remove(), 2000);
    } catch {
      window.location.href = t.uri;
    }
  }
}

// Turn any text into a destination: URL -> open; domain -> https; else Google search.
export function openQuery(raw) {
  const v = (raw || "").trim();
  if (!v) return;
  if (/^https?:\/\//i.test(v)) { window.open(v, "_blank", "noopener"); return; }
  if (/^[\w-]+(\.[\w-]+)+.*$/.test(v) && !v.includes(" ")) { window.open("https://" + v, "_blank", "noopener"); return; }
  window.open("https://www.google.com/search?q=" + encodeURIComponent(v), "_blank", "noopener");
}
